/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createInfinity } from '../../factoriesAny.js';
export var InfinityDependencies = {
  BigNumberDependencies,
  createInfinity
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesInfinity.generated.js
// module id = NCxT
// module chunks = 3